module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-inversionistas-grupos/catalogo-inversionistas-grupos.component.scss
// module id = ./src/app/components/catalogo-inversionistas-grupos/catalogo-inversionistas-grupos.component.scss
// module chunks = main